import { create } from "zustand";
import { devtools } from "zustand/middleware";
export var useDrawer = create()(devtools(function(set) {
    return {
        isDrawerOpen: false,
        setIsDrawerOpen: function(shouldOpen) {
            return set({
                isDrawerOpen: shouldOpen
            });
        }
    };
}));
